/**
 * Auth 패키지 설정 타입 정의
 * 각 앱별로 다른 OAuth2 및 API 설정을 주입할 수 있도록 함
 */

export interface OAuth2Config {
  clientId: string;
  clientSecret?: string;
  redirectUri: string;
  logoutRedirectUri?: string;
  scopes?: string[];
  tokenEndpoint?: string;
  userInfoEndpoint?: string;
}

export interface ApiConfig {
  baseUrl: string;
  authServerUrl: string;
  timeout?: number;
}

export interface StorageConfig {
  tokenKey?: string;
  userKey?: string;
  refreshTokenKey?: string;
  idTokenKey?: string;
  tokenTypeKey?: string;
  tokenExpiresAtKey?: string;
  storageType?: 'localStorage' | 'sessionStorage' | 'memory';
}

export interface AuthRoutesConfig {
  loginPath?: string;
  postLoginPath?: string;
}

export interface AuthConfig {
  appName: string;
  oauth2: OAuth2Config;
  api: ApiConfig;
  storage?: StorageConfig;
  routes?: AuthRoutesConfig;
  debug?: boolean;
}

// 기본 설정값
export const DEFAULT_AUTH_CONFIG: Partial<AuthConfig> = {
  storage: {
    tokenKey: 'auth_token',
    userKey: 'auth_user',
    refreshTokenKey: 'auth_refresh_token',
    idTokenKey: 'auth_id_token',
    tokenTypeKey: 'auth_token_type',
    tokenExpiresAtKey: 'auth_access_token_expires_at',
    storageType: 'localStorage'
  },
  debug: false
};

// 앱별 기본 설정 템플릿
export const createDefaultConfig = (appName: string): Partial<AuthConfig> => ({
  appName,
  api: {
    baseUrl: `https://api.ugot.uk`,
    authServerUrl: 'https://auth.ugot.uk'
  },
  oauth2: {
    clientId: `${appName}-client`,
    redirectUri: `https://app.ugot.uk/oauth2/redirect`,
    logoutRedirectUri: `https://app.ugot.uk/logout`,
    scopes: ['openid', 'profile', 'email']
  },
  routes: {
    loginPath: '/login',
    postLoginPath: '/',
  },
  ...DEFAULT_AUTH_CONFIG
});
